import { render, staticRenderFns } from "./EditorModal.vue?vue&type=template&id=1fe5fcb4&"
import script from "./EditorModal.vue?vue&type=script&lang=js&"
export * from "./EditorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports